import { createStore } from 'vuex';
import axios from 'axios';

const store = createStore({
  state: {
    // Auth state
    isAuthenticated: false,
    token: localStorage.getItem('auth_token') || null,
    profile: null,

    // Theme state
    isDarkMode: localStorage.getItem('theme') === 'dark' || false,
  },

  mutations: {
    // Authentication mutations
    setAuthentication(state, { token, profile }) {
      state.token = token;
      state.profile = profile;
      state.isAuthenticated = !!token;
      if (token) {
        localStorage.setItem('auth_token', token);
      } else {
        localStorage.removeItem('auth_token');
      }
    },
    logout(state) {
      state.token = null;
      state.profile = null;
      state.isAuthenticated = false;
      localStorage.removeItem('auth_token');
    },
    initializeStore(state) {
      const token = localStorage.getItem('auth_token');
      if (token) {
        state.token = token;
      }
    },

    // Theme mutations
    TOGGLE_THEME(state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
      document.body.classList.toggle('dark-mode', state.isDarkMode);
    },
    SET_THEME(state, isDark) {
      state.isDarkMode = isDark;
      localStorage.setItem('theme', isDark ? 'dark' : 'light');
      document.body.classList.toggle('dark-mode', isDark);
    },
  },

  actions: {
    // Authentication actions
    async login({ commit, dispatch }, { email, password }) {
      try {
        const res = await axios.post('users/token/', { email, password });
        const token = res.data.access;
        commit('setAuthentication', { token, profile: null });
        await dispatch('fetchProfileData');
      } catch (error) {
        throw error;
      }
    },
    async fetchProfileData({ commit, state }) {
      if (!state.token) return;
      try {
        const res = await axios.get('users/profile/', {
          headers: { Authorization: `Bearer ${state.token}` },
        });
        commit('setAuthentication', { token: state.token, profile: res.data });
      } catch (error) {
        commit('logout');
      }
    },
    logout({ commit }) {
      commit('logout');
    },

    // Theme actions
    toggleTheme({ commit }) {
      commit('TOGGLE_THEME');
    },
    initializeTheme({ commit }) {
      const savedTheme = localStorage.getItem('theme');
      commit('SET_THEME', savedTheme === 'dark');
    },
  },

  getters: {
    // Auth getters
    isAuthenticated: (state) => !!state.token || !!localStorage.getItem('auth_token'),
    token: (state) => state.token,
    profile: (state) => state.profile,

    // Theme getters
    isDarkMode: (state) => state.isDarkMode,
  },
});

export default store;
